import React, {useRef, useState} from 'react';
import { useDispatch } from 'react-redux';
import { usePopup } from '../../context/PopupContext';
import Loader from '../common/Loader';
import { AISearchResponse } from '../../services/actions/actions';

const AISearchTitlePopup = (props) => {
    const dispatch = useDispatch();
    const attributes = {
        profession: {
          header: "Use AI to Write",
          description: "Provide your job title to get tailored AI suggestions.",
          placeholder: "Input Job Title"
        },
        education: {
          header: "Use AI to Write",
          description: "Provide your field of study to get tailored AI suggestions.",
          placeholder: "Input  Field of Study"
        },
        heading: {
          header: "Use AI to Write",
          description: "Provide your job title to get tailored AI suggestions.",
          placeholder: "Input Job Title"
        }
    }
    const { boxContent, close, status, rightCallbackAction, leftCallbackAction, data, waiting, setWaiting } = usePopup();
    const [title, setTitle] = useState("");
    const [error, setError] = useState(null);
    const [loader, setLoader] = useState(false)
    
    const changeTitle = (e) => {
        setTitle(e.target.value);
    }

    const updateTitle = () => {
        data.title && setTitle(data.title)
    }

    const validateFields = () => {
        !Boolean(title) && setError({message: `Please ${attributes[data.section].placeholder.toLowerCase()}`})
    }

    const waitingHandler = () => {
        (Boolean(title) || data.title) && setLoader(true)
    }

    const closeAIPopup = () => {
        (!Boolean(title) && !Boolean(data.title)) && data.setShowAIPopup(false)
    }

    const rightButtonClickHandler = () => {
        updateTitle()
        validateFields()
        waitingHandler()
        getAIData()
    }

    const closeAction = () => {
        closeAIPopup()
        setTitle("")
        setLoader(false)
        setError(null)
    }

    const getAIData = () => {
        const phrase = (Boolean(title) ? title : data.title)
        phrase && dispatch(AISearchResponse(data.section, phrase, false)).then(res => {
            if(res.aidata.length){
                close('', () => {
                    if(rightCallbackAction != null) rightCallbackAction(false, {phrase: phrase})
                    closeAction()
                })
            }
        }).catch(error => {
            console.log(error);
        });
    }

    const titleRef = useRef(null);

    const getData = () => {
        if(!titleRef.current){
            titleRef.current = true
            rightButtonClickHandler()
        }
    }

    if(status('aientitytitlebox')) data.title && getData()

    return (<>
        {status('aientitytitlebox') && <><div className="transparent-popup-bg"></div>
            <div className="custom-skip-popup ai-entity-title-popup" ref={titleRef}>
                {!loader ?
                    <>
                        <div className="close-btn-icon">
                            <button className="close-icon" onClick={() => close('', closeAction)}>Close</button>
                        </div>
                        <div className="content-box">
                            <h4>{attributes[data.section].header}</h4>
                            <p>{attributes[data.section].description}</p>
                            <div className="ai-controls-wrapper">
                                <div className="download-icons-area">
                                    <input 
                                        id="ai_entity_title" 
                                        type="text" 
                                        name="ai_entity_title" 
                                        placeholder={attributes[data.section].placeholder}
                                        value={title} 
                                        onChange={ e => changeTitle(e) }
                                    />
                                       {error && <><div className="error">{error.message}</div></>}
                                </div>
                                <div className="button-area">
                                    <button className="skip" onClick={() => rightButtonClickHandler()}>Generate</button>
                                </div>
                            </div>
                         
                        </div>
                    </>
                    : <>
                        <div className="content-box">
                            <h4>Generating Content</h4>
                            <Loader />
                        </div>
                    </>
                }
            </div></>}
    </>)
}
export default AISearchTitlePopup;

